import * as types from '../actions/types'
import Immutable from 'immutable'


import {
    isPrimitive
} from '../utils/helpers'



const INITIAL_STATE = Immutable.fromJS({
    cotizaciones: [],
	page: 1,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: null,
		asc: false
	},
	modalFilter: {
        show: false,
        columnas: [],
		filters: []
	},
    modalSummary: {
		show: false,
        data: null
    },
    modalSummaryCotizaciones: {
		show: false,
        data: null
    },

})

export default function (state = INITIAL_STATE, action) {

    const columnas = state.getIn(['modalFilter', 'columnas'])

    switch (action.type) {
        case types.OBTENER_EXTERNOS_COTIZACIONES:
			state = state.set('cotizaciones', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords);
			return state
		case types.ORDENAR_EXTERNOS_COTIZACIONES:
			state = state.set('orderBy', action.payload.orderBy)
			return state
        // case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES:
        //     state = state.setIn(['modalFilter', 'show'], action.payload)
        //     return state


        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES:
            state = state.setIn(['modalFilter', 'show'], action.payload.state)
            state = state.setIn(['modalFilter', 'columnas'], Immutable.fromJS(action.payload.tableCols))
            return state

        case types.ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES:
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('value') === action.payload.value).get('type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state

		case types.CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES:
            state = state.set('showRecords', action.payload)
            return state


        case types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES:
            if (action.payload.show) {
                state = state.setIn(['modalSummary', 'show'], true)
                state = state.setIn(['modalSummary', 'data'], Immutable.fromJS(action.payload.data))
            } else {
                state = state.set('modalSummary', INITIAL_STATE.get('modalSummary'))
            }
            return state


        case types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD:

            if (action.payload.show) {
                state = state.setIn(['modalSummaryCotizaciones', 'show'], true)
                state = state.setIn(['modalSummaryCotizaciones', 'data'], Immutable.fromJS(action.payload.data))

                let cotizaciones = state.getIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones'])

                if (cotizaciones) {
                    cotizaciones.map((c,i) => {
                        state = state.setIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones', i, 'no_cotizar'], true)
                    })
                    try {
                        cotizaciones = state.getIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones']).sortBy(c => c.getIn(["bienes", 0, 'id']))
                        state = state.setIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones'], cotizaciones)
                    } catch (e) {
                        console.warn("No hay bienes para ordernar");
                    }
                }

            } else {
                state = state.set('modalSummaryCotizaciones', INITIAL_STATE.get('modalSummaryCotizaciones'))
            }
            return state


        case types.MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state

        case types.ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES:


            if (state.getIn(['modalSummary', 'show'])) {
                state = state.setIn(`${action.payload.path}`.split('.'), action.payload.data)
            }

            if (state.getIn(['modalSummaryCotizaciones', 'show'])) {
                state = state.setIn(`modalSummaryCotizaciones.data.solicitud.cotizaciones.0.adjunto`.split('.'), action.payload.data)
            }

            return state



        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/externoscotizaciones.js